import Api from "../../utils/api";
import Endpoints from "../../core/config/Endpoints";

export class OrderService {
    async add(data) {
        const token = localStorage.getItem("token");
        if (!token) {
            return null;
        }
        const response = await Api.post(Endpoints.order, data, {
            "Content-Type": "application/json",
            Authorization: token,
        });

        return response ?? null;
    }

    async get(id) {
        const token = localStorage.getItem("token");
        if (!token) {
            return null;
        }
        const response = await Api.get(`${Endpoints.order}/${id}`, {
            "Content-Type": "application/json",
            Authorization: token,
        });

        return response ?? null;
    }

    async update(id, data) {
        const token = localStorage.getItem("token");
        if (!token) {
            return null;
        }
        const response = await Api.patch(`${Endpoints.order}/${id}`, data, {
            "Content-Type": "application/json",
            Authorization: token,
        });

        return response ?? null;
    }

}
